import script from "./FileDistribution.vue?vue&type=script&setup=true&lang=js"
export * from "./FileDistribution.vue?vue&type=script&setup=true&lang=js"

import "./FileDistribution.vue?vue&type=style&index=0&id=7f05f538&scoped=true&lang=scss"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f05f538"]])

export default __exports__